import request from '@/utils/request'

const prefix = '/privilegeCode'

// 查询兑换码列表
export function page(query) {
  return request({
    url: `${prefix}/page`,
    method: 'get',
    params: query
  })
}

// 查询兑换码详情
export function detail(query) {
  return request({
    url: `${prefix}/detail`,
    method: 'get',
    params: query
  })
}

// 新增或修改兑换码
export function addOrUpdate(data) {
  return request({
    url: `${prefix}/addOrUpdate`,
    method: 'post',
    data: data
  })
}

export function codeEmailPage(query) {
  return request({
    url: `${prefix}/codeEmailPage`,
    method: 'get',
    params: query
  })
}
